import moment from 'moment';

let paymentTokenService = (paymentErrorService) => {
  let createToken;

  const setCreateToken = tokenCreator => createToken = tokenCreator;

  const getExpiryTimestamp = (duration = 5) => {
    return moment()
      .add(duration, 'minutes')
      .unix();
  };

  const generateToken = () => {
    if (createToken) {
      return createToken()
        .then(token => {
          if (!token.id) {
            throw { message: paymentErrorService.formatError(null) };
          }

          return {
            timestamp: getExpiryTimestamp(5),
            token: token.id,
            card: token.card || {}
          };
        })
        .catch(error => {
          throw [ error.message ];
        });
    }

    return Promise.reject([ 'No valid gateway found' ]);
  };

  const generatePaymentButtonToken = (createPaymentRequestButton, requestConfig) => {
    if (createPaymentRequestButton) {
      return createPaymentRequestButton(requestConfig)
        .then(paymentRequest => {
          if(paymentRequest) {
            return new Promise((resolve, reject) => {
              paymentRequest.on('paymentmethod', function (response) {
                if (response.error || !response.paymentMethod) {
                  response.complete('fail');
                  reject({ message: paymentErrorService.formatError(null) });
                }

                if (response.paymentMethod) {
                  response.complete('success');
                  resolve(response);
                }
              });
            });
          }
        })
        .catch(error => {
          throw [ error.message ];
        });
    }

    return Promise.reject([ 'No valid gateway found' ]);
  };

  return {
    setCreateToken,
    generateToken,
    generatePaymentButtonToken,
    getExpiryTimestamp
  };
};

paymentTokenService.$inject = [ 'paymentErrorService' ];

export default paymentTokenService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/payment.token.service.js